module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n      " + _vm._s(_vm.data.label) + "\n    ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": _vm.data.companyDataPerception.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data.companyDataPerception, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": 'number'
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyDataPerception.model, _vm.data.companyDataPerception.name)
      }
    },
    model: {
      value: (_vm.data.companyDataPerception.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyDataPerception, "model", $$v)
      },
      expression: "data.companyDataPerception.model"
    }
  }), _vm._v(" "), (_vm.verifyFields(_vm.data.companyDataPerception, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyDataPerception.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-011460ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SwitchPerception.vue
// module id = 608
// module chunks = 1